// not needed since all Theme setup is handled in ThemeProvider before AppBootstrap
// export async function bootstrapTheme(db) {
//   const themeMode = await db.settings.get("theme-mode"); //) || "auto";
//   const themeAccent = await db.settings.get("theme-accent"); //) || "default";

//   // const stored = localStorage.getItem(key) || "light";
//   document.documentElement.dataset.theme = themeMode.value || themeMode;
//   document.documentElement.dataset.themeAccent =
//     themeAccent.value || themeAccent;
//   // return stored;
//   return themeMode;
// }

export async function verifyServiceWorker({ timeoutMs = 1500 } = {}) {
  // ✅ Use window.* not bare globals
  if (!("serviceWorker" in navigator))
    return { ok: false, reason: "unsupported" };

  const isLocalhost = ["localhost", "127.0.0.1", "::1"].includes(
    typeof window !== "undefined" ? window.location.hostname : ""
  );

  if (
    typeof window !== "undefined" &&
    !window.isSecureContext &&
    !isLocalhost
  ) {
    return { ok: false, reason: "insecure-context" };
  }

  if (navigator.serviceWorker.controller)
    return { ok: true, reason: "controller-present" };

  const withTimeout = (p) =>
    Promise.race([
      p,
      new Promise((_, rej) =>
        setTimeout(() => rej(new Error("sw-timeout")), timeoutMs)
      ),
    ]);

  try {
    const reg = await withTimeout(navigator.serviceWorker.getRegistration());
    if (!reg) return { ok: false, reason: "no-registration" };
    if (reg.active) return { ok: true, reason: "active" };

    const sw = reg.waiting || reg.installing || reg.active;

    const activated = await withTimeout(
      new Promise((resolve) => {
        if (!sw) return resolve(false);
        if (sw.state === "activated") return resolve(true);
        const onState = () => {
          if (sw.state === "activated") {
            sw.removeEventListener("statechange", onState);
            resolve(true);
          }
        };
        sw.addEventListener("statechange", onState);
      })
    ).catch(() => false);

    return {
      ok: activated || !!reg.active || !!navigator.serviceWorker.controller,
      reason: activated ? "activated" : "not-activated-yet",
    };
  } catch (e) {
    return { ok: false, reason: e.message || "error" };
  }
}

// export async function pingAuth() {
//   try {
//     // Hit your lightweight refresh/introspect endpoint; credentials include cookies
//     const res = await fetch(`${process.env.REACT_APP_API}/v1/auth/session`, {
//       method: "GET",
//       credentials: "include",
//       headers: { Accept: "application/json" },
//     });
//     if (!res.ok) return { isAuthenticated: false };
//     const data = await res.json();
//     return { isAuthenticated: !!data?.authenticated, user: data?.user ?? null };
//   } catch {
//     return { isAuthenticated: false };
//   }
// }

// export async function verifyServiceWorker() {
//   if (!("serviceWorker" in navigator)) return;
//   try {
//     const reg = await navigator.serviceWorker.ready; // waits for active SW
//     return !!reg;
//   } catch {
//     /* ignore */
//   }
// }
